import AOS from 'aos';
const InitAos = () => {
  const ismatch = (str) => {
    let ret = null;
    const tab = [
      'data-aos_',
      'data-aos-delay_',
      'data-aos-duration_',
      'data-aos-easing_',
    ];
    tab.forEach(function (value) {
      if (String(str).match(value)) {
        ret = str.split('_');
        return false;
      }
    });
    return ret;
  };

  const elements = document.getElementsByClassName('some-class');
  Array.prototype.forEach.call(elements, function (el) {
    const tab = el.classList;
    Array.prototype.forEach.call(tab, function (item) {
      const ello = ismatch(item);
      if (ello !== null) el.setAttribute(ello[0], ello[1]);
    });
  });

  setTimeout(() => {
    AOS.init({
      startEvent: 'DOMContentLoaded',
    });
  }, 250);
  // window.addEventListener('DOMContentLoaded', (event) => {
  // });
};
export default InitAos;
